import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { AuthService } from 'src/app/auth.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[hasRole]',
  standalone: true,
})
export class HasRoleDirective implements OnInit, OnDestroy {
  @Input('hasRole') allowedRoles: string | string[] = [];
  @Input() hasRoleAction: 'hide' | 'disable' = 'hide';

  private userSubscription: Subscription;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.userSubscription = this.authService.userInfo$.subscribe((user) => {
      this.applyPermission(user?.type);
    });
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
  }

  private applyPermission(userRole: string): void {
    const rolesToCheck = Array.isArray(this.allowedRoles) ? this.allowedRoles : [this.allowedRoles];
    const hasPermission = rolesToCheck.includes(userRole);

    if (hasPermission) {
      this.showAndEnable();
    } else {
      if (this.hasRoleAction === 'hide') {
        this.hide();
      } else {
        this.disable();
      }
    }
  }

  private hide(): void {
    this.renderer.setStyle(this.elementRef.nativeElement, 'display', 'none');
  }

  private disable(): void {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
  }

  private showAndEnable(): void {
    this.renderer.removeStyle(this.elementRef.nativeElement, 'display');
    this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
  }
}
